export enum ActionTypes {
	RESET_EDITOR_STATE = 'RESET_EDITOR_STATE',
}

export type ResetEditorStateActionType = {
	type: ActionTypes.RESET_EDITOR_STATE;
};
